angular.module('leanlaw').directive('doubleSwitch', ['$window', $window => {
  return {
    restrict: "E",
    require: "ngModel",
    replace: true,
    template: require("./views/doubleswitch.html"),
    scope: {
      ngModel: "=",
      options: "=",
      stickyKey: "@?"
    },
    link: function ($scope, element, attrs) {
      // Key to store value in localStorage
      const storageKey = `stickyToggle:${$scope.stickyKey}`;
      if ($scope.stickyKey && $window.localStorage) $scope.ngModel = $window.localStorage.getItem(storageKey);
      if (!$scope.ngModel) {
        $scope.ngModel = $scope.options[0];
        saveModel();
      }
      $scope.toggleSwitch = function toggleSwitch() {
        const idx = $scope.options.indexOf($scope.ngModel);
        $scope.ngModel = $scope.options[(idx + 1) % 2];
        saveModel();
      };
      $scope.setSwitch = function setSwitch(index) {
        $scope.ngModel = $scope.options[index];
        saveModel();
      };
      function saveModel() {
        if ($window.localStorage && $scope.stickyKey) $window.localStorage.setItem(storageKey, $scope.ngModel);
      }
    }
  };
}]);